import React from 'react';
import Style from './index.module.scss';
import {FunctionListTree} from '../../service';
import {CaretDownOutlined, CaretUpOutlined} from '@ant-design/icons';
import {useToggle} from 'react-use';
import {AuthCardItem} from '../AuthCardItem';

interface Props {
    roleId: string;
    data: FunctionListTree;
    onChange(): void;
}
const Index = ({roleId, data, onChange}: Props) => {
    const [open, toggleOpen] = useToggle(true);

    return (
        <div className={Style.root}>
            <div className={Style.title} onClick={toggleOpen}>
                {data.name} {open ? <CaretUpOutlined /> : <CaretDownOutlined />}
            </div>

            <div hidden={!open}>
                {data?.children?.map(item => (
                    <AuthCardItem
                        key={item.id}
                        roleId={roleId}
                        data={item}
                        onChange={onChange}
                    />
                ))}
            </div>
        </div>
    );
};

export default Index;
